<cv-current-hold-times-pm
    *ngIf="!config.isCxOne"
    [moduleManager]="moduleManager"
    [moduleKey]="moduleKey">
</cv-current-hold-times-pm>